import type { ReactElement } from 'react';
import { Box } from '@mantine/core';
import { Activity } from 'lucide-react';
import PageHeaderComponent from '@/design/PageHeaderComponent';
import PageLevelFilterRow from '@/shared/surfaces/PageLevelFilterRow';
import SurfaceAssistScope, { SurfaceAssistToolbar } from '@/shared/surfaces/assist/SurfaceAssistScope';
import { SurfaceActivityTab } from '@/shared/surfaces/SurfaceActivityTabsBody';
import { useSurface } from '@/shared/surfaces/useSurface';
import TopicNotFound from '@/shared/surfaces/TopicNotFound';
import { BEHAVIOR_ACTIVITY_COLUMNS } from './BehaviorActivityColumns';

/** The Behavior turn feed as its own interior-nav view: every turn of work, newest first. */
export default function BehaviorActivityPage(): ReactElement {
    const surface = useSurface('behavior');
    if (surface === undefined) return <TopicNotFound />;
    return (
        <SurfaceAssistScope surface={surface}>
            <Box pb="xl">
                <PageLevelFilterRow assist={<SurfaceAssistToolbar surface={surface} />} />

                <PageHeaderComponent
                    icon={Activity}
                    eyebrow="Behavior"
                    title="Activity"
                    subtitle="Every prompt of work, newest first — which model, what kind and difficulty of task, and how deep into the conversation it happened."
                />

                <SurfaceActivityTab accent="indigo" intro="Open a row to read the full prompt." persistenceKey="usage-activity" columns={BEHAVIOR_ACTIVITY_COLUMNS} />
            </Box>
        </SurfaceAssistScope>
    );
}
